import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';

// Configure Amplify with the new approach
const config = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_QLIR5NFnx',
      // userPoolClientId: '52nab8ipe112hmpnc7t7rhitke',
      userPoolClientId: '5btemk829r1basaumt5hqsk5a6',
      region: 'us-east-1',
      loginWith: {
        oauth: {
          domain: 'us-east-1qlir5nfnx.auth.us-east-1.amazoncognito.com',
          scopes: ['email', 'openid', 'profile'],//
          redirectSignIn: ['http://localhost:3000/api/v1/auth/callback'],
          redirectSignOut: ['https://pam-dev.cruugo.me/'],
          responseType: 'code'
        },
      }
    }
  }
};

// /
// const config = {
//   Auth: {
//     Cognito: {
//       userPoolId: 'us-east-1_Rdt3L9U95',
//       // userPoolClientId: '52nab8ipe112hmpnc7t7rhitke',
//       userPoolClientId: '3p8arfqppvkhf0cqsfgunt1qui',
//       region: 'us-east-1',
//       loginWith: {
//         oauth: {
//           domain: 'us-east-1rdt3l9u95.auth.us-east-1.amazoncognito.com',
//           scopes: ['aws.cognito.signin.user.admin'],//
//           redirectSignIn: ['http://localhost:8000/api/v1/auth/callback'],
//           redirectSignOut: ['https://pam-dev.cruugo.me/'],
//           responseType: 'code'
//         },
//       }
//     }
//   }
// };


Amplify.configure(config);

// index.js
// import { AuthProvider } from "react-oidc-context";

// const cognitoAuthConfig = {
//   authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_QLIR5NFnx",
//   client_id: "5btemk829r1basaumt5hqsk5a6",
//   redirect_uri: "http://localhost:8000/api/v1/auth/callback",
//   response_type: "code",
//   scope: "aws.cognito.signin.user.admin email openid phone profile",
// };

// const root = ReactDOM.createRoot(document.getElementById("root"));

// // wrap the application with AuthProvider
// root.render(
//   <React.StrictMode>
//     <AuthProvider {...cognitoAuthConfig}>
//       <App />
//     </AuthProvider>
//   </React.StrictMode>
// );

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
